import React, { useState } from "react";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import dayjs from "dayjs";
import { Tag, Tooltip } from "antd";
import {
  FileTextOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  ClockCircleOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  CloseCircleTwoTone,
  SyncOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import { useNavigate } from "react-router";
const TenderPendingApprovalsList = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const columns = [
    {
      title: "Tender ID",
      dataIndex: "tenderNumber",
      key: "tenderNumber",
      fixed: "left",
      width: 170,
      render(text: any, record: any) {
        return (
          <>
            <Tooltip title={"Click To View Tender Details"}>
              <span
                className="inlineTableCellLink"
                onClick={() => {
                  navigate(`/tender/view-tender/${record.tenderId}`, {
                    state: {
                      tenderId: record.tenderId,
                      screenName: "Pending Approval",
                      status: record.status,
                    },
                  });
                }}
              >
                {text}
              </span>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "tenderTitle",
      key: "tenderTitle",
      render: (text: string) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 180,
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "tenderType",
      key: "tenderType",
      width: 130,
      render: (type: string) => (
        <Tag
          color={type === "Open" ? "green" : "blue"}
          icon={type === "Open" ? <FolderOpenOutlined /> : <FolderOutlined />}
        >
          {type}
        </Tag>
      ),
    },
    {
      title: "Tender For",
      dataIndex: "tenderFor",
      width: 130,
      key: "tenderFor",
      render: (tenderFor: string) => (
        <Tag color={tenderFor === "Material" ? "purple" : "cyan"}>
          {tenderFor}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status: string) => {
        const statusMap: Record<string, { color: string; icon: JSX.Element }> =
          {
            Draft: {
              color: "geekblue",
              icon: <ClockCircleOutlined />,
            },
            Published: { color: "cyan", icon: <CheckCircleTwoTone /> },
            "Not Interested": {
              color: "default",
              icon: <CloseCircleTwoTone twoToneColor="#d9d9d9" />,
            },
            Responded: { color: "purple", icon: <FileTextOutlined /> },
            Negotiation: { color: "orange", icon: <SyncOutlined /> },
            "Pending Approval": {
              color: "gold",
              icon: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
            },
            Awarded: {
              color: "green",
              icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
            },
            Cancelled: {
              color: "red",
              icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
            },
          };
        const { color, icon } = statusMap[status] || {
          color: "default",
          icon: <FileTextOutlined />,
        };
        return (
          <Tag color={color} icon={icon}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: "Site / Project",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
      render: (text: string) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 160,
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "EOI Deadline",
      dataIndex: "lastDateForExpressingInterest",
      key: "lastDateForExpressingInterest",
      render: (date: any) => date ? dayjs(date).format("DD-MMM-YYYY") : "--",
      width: 120,
    },
    {
      title: "Submission Deadline",
      dataIndex: "lastSubmissionDate",
      key: "lastSubmissionDate",
      render: (date: any) => date ? dayjs(date).format("DD-MMM-YYYY") : "--",
      width: 160,
    },
  ];
  return (
    <TransactionFlowDefaultTemplate
      moduleKey="pending Approvals"
      title="Pending Approvals"
      columns={columns}
      selectFilters={[
        {
          title: "Status",
          placeholder: "Select Status",
          options: [
            { value: "All", label: "All" },
            { value: "Pending Approval", label: "Pending Approval" },
          ],
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: false,
        excelExport: false,
      }}
    />
  );
};

export default TenderPendingApprovalsList;
